export const assortmentSimulationDetailEn = {
  backToSimulations: "Back to Simulations",
  majorSimulation: "Major Simulation",
  minorSimulation: "Minor Simulation",
  lastUpdated: "Last updated",
  export: "Export",
  saveChanges: "Save Changes",
  update: "Update",

  assortment: {
    title: "Assortment",
    activeProducts: "active products",
    ai: "AI",
    manual: "Manual",
    added: "Added",
    removed: "Removed",
    addProduct: "Add Product",
    sourcePog: "Planogram Data",
    sourcePerformance: "Performance Data",
    sourceRecommendationsOnly: "Recommendations Only",
    segmentation: "Segmentation",
  },

  segmentLevel: {
    General: "General",
    Store: "Store",
    Cluster: "Cluster",
    "Cluster Category": "Category Cluster",
    "Cluster Institucional": "Institutional Cluster",
    "Cluster Institutional": "Institutional Cluster",
    store: "Store",
    cluster: "Institutional Cluster",
    "cluster-category": "Category Cluster",
    general: "General",
    country: "Country",
  },

  search: {
    placeholder: "Search products",
  },

  filters: {
    allClusters: "All Clusters",
    allCatClusters: "All Cat. Clusters",
    allInstClusters: "All Inst. Clusters",
    allStores: "All Stores",
    allOrigins: "All Origins",
    allStatus: "All Status",
    existing: "Existing",
    new: "New",
  },

  table: {
    product: "Product",
    cluster: "Cluster",
    catCluster: "Cat. Cluster",
    instCluster: "Inst. Cluster",
    store: "Store",
    cpiScoreRank: "CPI Score & Rank",
    projectedSales: "Projected Sales",
    score: "Score",
    origin: "Origin",
    status: "Status",
    actions: "Actions",
    view: "View",
    restore: "Restore",
    active: "Active",
  },

  comparison: {
    title: "Before & After Comparison",
    subtitle: "Key performance metrics comparison",
    metric: "Metric",
    before: "Before",
    after: "After",
    change: "Change",
  },

  space: {
    title: "Planogram Space Utilization",
    subtitle: "Linear space allocation by",
    subcategory: "Subcategory",
    brand: "Brand",
    status: "Status",
    statusExisting: "Existing",
    statusNew: "New",
    statusAvailable: "Available",
    statusRemoved: "Removed",
    totalLinearSpace: "Total linear space",
    nearCapacity: "Near capacity",
    highUtilization: "High utilization",
    availableSpace: "Available space",
    free: "free",
    noData: "No space data available for the current selection",
  },

  addModal: {
    title: "Add Product to Assortment",
    subtitle: "Select products from the catalog to add to this simulation",
    searchPlaceholder: "Search available products",
    add: "Add",
    close: "Close",
    noProducts: "No products available",
    noProductsSearch: "No products match your search criteria.",
    noProductsAll: "All products have been added to the assortment.",
    score: "Score",
    projectedSales: "Projected Sales",
    selectStorePlaceholder: "Select a store...",
    filters: {
      allSubcategories: "All subcategories",
      allBrands: "All brands",
      allSegments: "All segments",
    },
    tooltip: {
      sku: "SKU",
      cpi: "CPI",
      projectedImpact: "Projected impact",
      subcategory: "Subcategory",
      brand: "Brand",
      segment: "Segment",
      size: "Size",
      width: "Width",
    },
  },

  rowTooltip: {
    sku: "SKU",
    fsi: "FSI",
    cpi: "CPI",
    space: "Space",
    projectedImpact: "Projected impact",
    width: "Width",
    subcategory: "Subcategory",
    brand: "Brand",
    segment: "Segment",
    size: "Size",
  },

  detailModal: {
    segment: "Segment",
    source: "Source",
    salesAmount: "Sales",
    unitsLabel: "Units",
    daysOnHand: "Days on Hand",
    cpiAndFsi: "CPI {{cpi}}, FSI {{fsi}}",
    overallScore: "Overall Score",
    projectedSales: "Projected Sales",
    linearSpace: "Linear Space",
    rotation: "Rotation",
    margin: "Margin",
    historicalSales: "Historical Sales",
    complementarity: "Complementarity",
    trend: "Trend",
    performanceMetrics: "Performance Metrics",
    newlyAdded: "Newly Added",
    removedFromAssortment: "Removed from Assortment",
    existingProduct: "Existing Product",
    removeFromAssortment: "Remove from Assortment",
    close: "Close",
    reason: "Reason",
  },
} as const;

export type AssortmentSimulationDetailTranslations = typeof assortmentSimulationDetailEn;
